import React from 'react'
import { useSelector } from 'react-redux'
import { useFetch } from 'hooks'
import { getLocation } from 'ducks/router'
import { usePuppeteerGoto } from 'hooks'
import { fetchInterviewTemplateByUUID } from 'api/interviewTemplates'

export const useTemplate = () => {
  const {
    payload: { uuid },
  } = useSelector(getLocation)

  const handleFetch = React.useCallback(
    async () => await fetchInterviewTemplateByUUID({ uuid }),
    [uuid],
  )

  const {
    state: { response, isFetching },
  } = useFetch<{ sections?: any[]; title?: string }>(handleFetch)

  usePuppeteerGoto()

  return {
    state: { response, isFetching },
  }
}
